import { Price } from 'src/types';
import { filterOffersGeneric } from './filtering-generic';
import { getFiltersConfig } from './filters-config';
import { IFilterTypeSelection } from './types';

export const filterOffersBySelections = (
  offers: Price[],
  filterSelections: IFilterTypeSelection[]
): Price[] => {
  const configs = getFiltersConfig();
  let filteredOffers = offers;
  filterSelections.forEach(filterSelection => {
    const config = configs.find(c => c.type === filterSelection.type);
    if (config) {
      filteredOffers = filterOffersGeneric(
        filteredOffers,
        config,
        filterSelection.selection
      );
    }
  });
  return filteredOffers;
};
